import { createContext, useMemo, createElement } from 'react';

function warnNoProvider() {
  // eslint-disable-next-line no-console
  console.warn("[constate] Missing Provider");
} // istanbul ignore next


var canUseProxy = process.env.NODE_ENV === "development" && typeof Proxy !== "undefined"; // istanbul ignore next

var defaultValue = canUseProxy ? new Proxy({}, {
  get: warnNoProvider,
  apply: warnNoProvider
}) : {};

function createContainer(useValue, createMemoInputs) {
  var Context = createContext(defaultValue);

  var Provider = function Provider(props) {
    var value = useValue(props); // createMemoInputs won't change between renders

    var memoizedValue = createMemoInputs ? useMemo(function () {
      return value;
    }, createMemoInputs(value)) : value;
    return createElement(Context.Provider, {
      value: memoizedValue
    }, props.children);
  };

  return {
    Context: Context,
    Provider: Provider
  };
}

export default createContainer;